import { Navigate, Route, Routes } from 'react-router-dom';

import { AuthProvider, useAuth } from './lib/auth';
import { Nav } from './components/Nav';
import { Login } from './routes/Login';
import { Feed } from './routes/Feed';
import { Sources } from './routes/Sources';
import { Settings } from './routes/Settings';

function Shell() {
  const { user, loading } = useAuth();

  if (loading) {
    return <div className="center muted">Loading…</div>;
  }

  if (!user) {
    return <Login />;
  }

  return (
    <div className="app">
      <Nav />
      <main className="content">
        <Routes>
          <Route path="/" element={<Feed />} />
          <Route path="/sources" element={<Sources />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
    </div>
  );
}

export function App() {
  return (
    <AuthProvider>
      <Shell />
    </AuthProvider>
  );
}
